import { Box, Button, CircularProgress, Icon, IconButton, Link, Paper, Stack, Typography } from "@mui/material"
import { toastError } from "../../redux/guest-slices/other.slice"
import { userLoginReq } from "../../redux/admin-slices/auth.slice"
import InputFieldA from "../../components/ui/InputFieldA"
import { useDispatch, useSelector } from "react-redux"
import { Link as NavLink } from "react-router-dom"
import Icons from "../../assets/js/Icons"
import { useState } from "react"

function Login() {
  const dispatch = useDispatch()
  const [show, setShow] = useState(false)
  const { other } = useSelector(state => state.authSlice)

  // Handle user signup 
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)
    if (
      Object.keys(formData)?.some((field) => {
        const value = formData[field]
        return (value?.trim() === "" || !value)
      })
    ) {
      return dispatch(toastError("Please fill all required field!"))
    }
    formData.usertimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    dispatch(userLoginReq(formData))
  }

  return (
    <Box
      sx={{
        display: "grid",
        minHeight: "100vh",
        alignItems: "center",
      }}
    >
      <Paper
        sx={{
          p: 3,
          mx: "auto",
          width: "100%",
          display: "block",
          maxWidth: "450px",
          // border: "1px solid #f0f0f0",
          boxShadow: "0 0 40px 0 #0000001a",
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Typography
          mb={3}
          fontSize={24}
          fontWeight="700"
          textAlign="center"
        >Admin Login
        </Typography>

        <Stack spacing={3}>
          <Box>
            <InputFieldA
              type="email"
              name="email"
              label="Email"
              placeholder="Email Address"
              startIcon={
                <Icon sx={{ fontSize: "20px", color: "other.color1", mr: 0.5 }}>
                  <Icons.MailSolid />
                </Icon>
              }
            />
          </Box>
          <Box>
            <InputFieldA
              name="password"
              label="Password"
              placeholder="Password"
              type={show ? "text" : "password"}
              startIcon={
                <Icon sx={{ fontSize: "20px", color: "other.color1", mr: 0.5 }}>
                  <Icons.PasswordSolid />
                </Icon>
              }
              endIcon={
                <IconButton
                  size="small"
                  type="button"
                  onClick={() => { setShow(!show) }}
                  sx={{ fontSize: "20px", color: "other.color1" }}
                >
                  {!show ?
                    <Icons.ViewSolidSharp /> :
                    <Icons.ViewOffSolidSharp />
                  }
                </IconButton>
              }
            />
            <Typography
              mt={1}
              fontSize={14}
              textAlign="end"
              color="other.color1"
            >
              <Link
                underline="hover"
                component={NavLink}
                to="/forgot-password"
              >Forgot password?
              </Link>
            </Typography>
          </Box>
          <Button
            sx={{
              p: "9px 17px",
              lineHeight: "1.5",
              fontSize: "18px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
            endIcon={
              other?.loadingLogin &&
              <CircularProgress
                size={22}
                color="text"
                thickness={6}
              />
            }
          >Login
          </Button>
        </Stack>
      </Paper>
    </Box >
  )
}

export default Login